import { call, put, getContext, takeEvery, select } from 'redux-saga/effects';
import { SubmissionError, FormAction as BaseFormAction } from 'redux-form';
import { ApolloError } from 'apollo-client';
import { FirstFactorAuthorizationResponse } from '@unitedtraders/keycloak';
import { actions as appActions } from '../../../../actions/app';
import { actions } from '../../actions';
import { SagaContext } from '../../../../types/common';
import * as gtmDataLayer from '../../../../utils/gtmDataLayer';
import { routine } from './actions';
import { FormData } from './constraints';
import { Services } from 'init/services';
import { PRODUCT } from '../../../../consts';
import { languageSelector } from '../../../../selectors/app';
import { getFormErrors } from 'shared/utils/formatError';
import { lifecycle } from '../../actions';

interface FormAction extends BaseFormAction {
  payload: {
    values: FormData;
  };
}

// @translate
type Errors =
  | 'invalid_grant'
  | 'InvalidCredentialsException'
  | 'RateLimitExceededException'
  | 'UserSoftBlockedException';

function* saga() {
  const keycloakService: Services['keycloakService'] = yield getContext(
    SagaContext.KeycloakService
  );

  yield takeEvery(routine.TRIGGER, function* ({ payload: { values } }: FormAction) {
    const { username, password } = values;

    const locale: ReturnType<typeof languageSelector> = yield select(languageSelector);

    try {
      const response: FirstFactorAuthorizationResponse = yield call(() =>
        keycloakService.authorizeByFirstFactor(username.trim(), password, PRODUCT, locale)
      );

      if (response.otpType !== 'OTP_DISABLED') {
        yield put(routine.success(response));
        yield put(
          actions.changeStage(
            'code',
            response.otpType === 'OTP_EMAIL' ? 'email' : 'googleAuthenticator',
            response.secondFactorRequestId
          )
        );
        return;
      }

      gtmDataLayer.push({
        eventCategory: 'form',
        eventAction: 'login',
        eventLabel: 'login-success',
      });

      yield put(appActions.login());
      yield put(routine.success());
      yield put(lifecycle.deactivate());
    } catch (e: ApolloError | any) {
      // details.message is not translate friendly, so use exception name in type field
      // type can be 'com.unitedtraders.luna.sessionservice.exceptions.InvalidCredentialsException'
      const error = getFormErrors(e);
      yield put(routine.failure(new SubmissionError<FormData, Errors>(error)));
    }
  });
}

export default saga;
